import { gql } from "graphql-request";
import { ID } from "../../Types";

export const GET_CURRENT_USER_QUERY = gql`
  query GetCurrentUserQuery {
    me {
      adminOn
      avatarUrl
      displayName
      email
      id
      currencyCode
      geographicalRegion {
        code
      }
      company {
        id
        name
      }
    }
  }
`;

export type GetCurrentUserDTO = {
  me: {
    adminOn: boolean;
    avatarUrl: string;
    displayName: string;
    email: string;
    id: ID;
    currencyCode: string;
    geographicalRegion: {
      code: string;
    };
    company: {
      id: ID;
      name: string;
    } | null;
  };
};

export type GetCurrentUserQueryParams = {};
